define('shared/util/fields/Telephone',[
    'shared/initializer/form/constants',
    'shared/util/state', 
    'shared/util/hub', 
    'shared/lib/RSVP'
], 
function (
    constants,
    state, 
    hub,
    RSVP
) {
    'use strict';

    var patterns;

    function createChuanr(options) {
        var me = this;

        if ( options == null ) {
            options = { };
        }

        return processPatterns.call(me, options)
            .then(function(){
                var pttns = patterns.slice();
                me.chuanr = me.createChuanrDelegate.call(me, pttns);
            });
    }

    function refreshChuanr( forceClear ){
        var me = this;
        if ( forceClear ) {
            me.$el.val('');
        }

        return createChuanr.call(me)
            .then(function(){
                me.onChuanrRefreshed.call(me, me.chuanr);
            });
    }

    function getEtownMarketPhonePatterns(market) {
        var countryPattern;

        countryPattern = hub.peek('/form/lead/telephone/pattern');

        if ( countryPattern == null ) {
            countryPattern = [];
            outer:
                for(var ind in window.etMarketPhonePatterns) {
                    inner:
                        for(var country in window.etMarketPhonePatterns[ind]) {
                            if(country === market) {
                                countryPattern  =   window.etMarketPhonePatterns[ind][country];
                                break outer;
                            }
                        }
                }
        }

        var patterns = [];
        if( countryPattern.length > 0 ) {
            for(var i = 0; i < countryPattern.length; i++) {
                patterns.push(countryPattern[i]);
            }
        }

        for( var l = patterns.length; l--;) {
            if ( patterns[l] + '' == false ) {
                patterns.splice(l, 1);
            }
        }

        if ( patterns.length <= 0 ) {
            patterns = getDefaultPatterns();
        }

        return patterns;
    }

    function getCurrentPhoneType($phoneTypeElement){
        var currentPhoneType = constants.PhoneType.Landline;
        if($phoneTypeElement && $phoneTypeElement.is(':visible')){
            currentPhoneType = $phoneTypeElement.filter(':checked').val();
        }

        return currentPhoneType;
    }

    function processPatterns( options ) {
        return new RSVP.Promise(function( resolve ){
            if ( options && options.market ) {
                resolve( options.market );
            }
            else {
                state.get('user.market', function(userMarket){
                    resolve( userMarket );
                });
            }
        })
        .then(
            function( market ){
                patterns = getEtownMarketPhonePatterns( market );
            },
            RSVP.resolve
        );
    }

    function getDefaultPatterns() {
        return [
            '{dddddd}',
            '{ddddddd}',
            '{dddddddd}',
            '{ddddddddd}',
            '{dddddddddd}',
            '{ddddddddddd}',
            '{dddddddddddd}',
            '{ddddddddddddd}',
            '{dddddddddddddd}',
            '{ddddddddddddddd}',
            '_|{dd(=)d(=)d(=)d(=)d(=)?????????}'
        ];
    }

    function setupChuanrRefresh(createChuanrDelegate, onChuanrRefreshed) {
        var me = this;
        me.createChuanrDelegate = createChuanrDelegate;
        me.onChuanrRefreshed = onChuanrRefreshed;

        me.$el.on('chuanr.refresh', function(evt, options){
            refreshChuanr.call(me, options.forceClear);
        });
    }

    function Ctor($el, chuanr){
        var me = this;
        me.$el = $el;
        me.chuanr = chuanr;
    }

    Ctor.prototype.setupChuanrRefresh = setupChuanrRefresh;
    Ctor.getEtownMarketPhonePatterns = getEtownMarketPhonePatterns;
    Ctor.getCurrentPhoneType = getCurrentPhoneType;

    return Ctor;
});
